import React, { useState, useEffect } from "react";
import "./movie-list.scss";
import { SwiperSlide, Swiper } from "swiper/react";
import tmdbApi, { category } from "../../api/tmdbApi";
import MovieCard from "../movie-card/MovieCard";
import animeApi, { animeType } from "../../api/animeApi";

const MovieList = ({ cat, type, id }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const getList = async () => {
      let response = null;
      const params = {};
      let isAnime = false;
      if (type !== "similar") {
        switch (cat) {
          case category.movie:
            response = await tmdbApi.getMoviesList(type, { params });
            break;
          case category.anime:
            isAnime = true;
            response = await animeApi.getAnimeList(type, animeType.top);
            break;
          default:
            response = await tmdbApi.getTvList(type, { params });
        }
      } else {
        response = await tmdbApi.similar(cat, id);
      }
      isAnime ? setItems(response.data) : setItems(response.results);
    };
    getList();
  }, [cat, id, type]);

  return (
    <div className="movie-list">
      <Swiper
        grabCursor={true}
        spaceBetween={10}
        slidesPerView={"auto"}
        cssMode={true}
      >
        {items.map((item, i) => (
          <SwiperSlide key={i}>
            <MovieCard item={item} cat={cat} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default MovieList;
